import {Component, EventEmitter, Input, Output} from '@angular/core';
import Fuse from 'fuse.js';
import {BasePagination} from '../pagination/model/abstract/pagination.abstract';
import {PaginationProperties} from '../pagination/model/pagination.properties';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: false,
})
export class SearchBarComponent extends BasePagination {
  @Input() placeholderTitle: string;
  @Input() data: any[];
  @Input() searchTerm: string;
  @Input() searchProperties: any;
  @Input() page: number;
  @Input() step: number;

  @Output() updateDisplayData: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  public updateDisplayDataEventEmitter(): void {
    this.updateDisplayData.emit(this.setPaginationProperties());
  }

  public setPaginationProperties(): PaginationProperties {
    const paginationProperties = new PaginationProperties();

    paginationProperties.setDisplayedData(this.updateDisplayedDataArray(this.step, 0));
    paginationProperties.setMaxPage(this.retrieveMaxPage());
    paginationProperties.setPages(this.setPages());
    paginationProperties.setIsNextButtonDisabled(this.setDisableNextButton());
    paginationProperties.setIsPreviousButtonDisabled(this.setDisablePreviousButton());
    paginationProperties.setFilteredData(this.filterDataBySearchTerm());

    return paginationProperties;
  }

  public updateDisplayedDataArray(step: number, page: number): any {
    const currentDisplayedData = [];
    const searchedData = this.filterDataBySearchTerm();

    for (let i = page * step; i < step + page * step; i++) {
      if (searchedData[i]) {
        currentDisplayedData.push(searchedData[i]);
      } else {
        break;
      }
    }

    return currentDisplayedData;
  }

  public retrieveMaxPage(): number {
    return Math.ceil(this.filterDataBySearchTerm().length / this.step);
  }

  public setPages(): number[] {
    const pages = [];
    for (let i = 0; i < this.retrieveMaxPage(); i++) {
      pages.push(i);
    }
    return pages;
  }

  public setDisablePreviousButton(): boolean {
    return this.page <= 0;
  }

  public setDisableNextButton(): boolean {
    return this.page >= this.retrieveMaxPage() - 1;
  }

  public filterDataBySearchTerm(): any[] {
    let results: any[];

    if (this.searchTerm === undefined || this.searchTerm === null ||
      this.searchTerm === '') {
      results = this.data;
    } else {
      const fuse = new Fuse(this.data, this.searchProperties);
      results = fuse.search(this.searchTerm).map(result => result.item);
    }

    return results;
  }
}
